<script>
  import { modalStore } from '../state/store'
  import { fade } from 'svelte/transition'
  import Icon from './Icon.svelte'

  export let large
  export let name

  const closeModal = () => modalStore.toggle(name, false)
</script>

<style>
  .modal-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--bg-overlay);
  }

  .modal {
    position: fixed;
    left: 50%;
    top: 50%;
    width: calc(100vw - 4em);
    max-width: 32em;
    max-height: calc(100vh - 2em);
    overflow: auto;
    transform: translate(-50%, -50%);
    padding: 1em;
    border-radius: 0.2em;
    background-color: white;
  }

  .large {
    max-height: 99vh;
    height: 99vh;
    max-width: 95vw;
    width: 95vw;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  button {
    background-color: transparent;
    border: none;
  }

</style>

{#if $modalStore[name]}

<div class="modal-background" on:click="{closeModal}" transition:fade|global={{duration: 100}}></div>

<div class="modal" class:large={large === 'true'} transition:fade|global={{duration: 100}}>
  <div class="modal-header">
    <slot name="header"></slot>
    <button on:click="{closeModal}"><Icon name='close' size='large'/></button>
  </div>

  <slot></slot>
</div>
{/if}
